<template>
  <v-layout justify-center>
    <p class="mb-0">{{ item.Size }}</p>
    <v-tooltip v-model="show[index]" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-sheet
          width="16"
          height="16"
          color="grey lighten-3 ml-1"
          class="rounded-circle"
        >
          <p class="mb-0 cursor text-color" v-bind="attrs" v-on="on">
            {{ getcurrency }}
          </p>
        </v-sheet>
      </template>
      <span v-if="currency">
        <div v-for="(productVariant, i) in product.Variants" :key="i">
          <div v-if="currency">
            {{
              productVariant.Code +
              ": " +
              getcurrency +
              correctItemPrice(
                stockItems
                  ? productVariant.Reserved.find((el) => el.Size == item.Size)
                  : productVariant.Stock.find((el) => el.Size == item.Size)
              )
            }}
          </div>
        </div>
      </span>
      <!--  <span > {{ getcurrency + 0 }} </span> -->
    </v-tooltip>
  </v-layout>
</template>
  
  <script>
export default {
  props: ["item", "index", "product", "currencyItem", "stockItems"],
  data() {
    return {
      show: [],
      currency: this.currencyItem,
    };
  },
  computed: {
    getcurrency() {
      let currencySign;
      switch (this.currency) {
        case "EUR":
          currencySign = "€ ";
          break;
        case "GBP":
          currencySign = "£ ";
          break;
        case "USD":
          currencySign = "$ ";
          break;

        default:
          currencySign = "€ ";
          break;
      }
      return currencySign;
    },
  },
  methods: {
    correctItemPrice(item) {
      if (!item) {
        return 0;
      }
      let price = 0;
      item.NetPrices.forEach((element) => {
        if (element.Code == this.currency) {
          return (price = element.Price);
        }
      });
      return price;
    },
    changeCurrency(currency) {
      if (currency) {
        this.currency = currency;
      }
    },
  },
};
</script>
  
  <style>
</style>